import { msg } from '@gonfalon/messages/msg';
import { Tag, TagGroup, TagList, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

const MAX_VISIBLE_ATTRIBUTES = 2;
const OVERFLOW_TAG_ID = 'overflow';

function toColumnTagId(column: string) {
  return `column:${column}`;
}

export function AttributeColumnsTagGroup({ dataSourceName, columns }: { dataSourceName: string; columns: string[] }) {
  const visibleColumns = columns.slice(0, MAX_VISIBLE_ATTRIBUTES);
  const hiddenColumns = columns.slice(MAX_VISIBLE_ATTRIBUTES);

  return (
    <TagGroup aria-label={msg('dataSources.listPage.attributesTagsLabel', { name: dataSourceName })}>
      <TagList>
        {visibleColumns.map((column) => (
          <Tag key={column} id={toColumnTagId(column)} textValue={column} size="small">
            {column}
          </Tag>
        ))}
        {hiddenColumns.length > 0 ? (
          <TooltipTrigger>
            <Tag
              id={OVERFLOW_TAG_ID}
              size="small"
              textValue={msg('dataSources.listPage.moreAttributesLabel', { count: hiddenColumns.length })}
            >
              {msg('dataSources.listPage.moreAttributes', { count: hiddenColumns.length })}
            </Tag>
            <Tooltip>{hiddenColumns.join(', ')}</Tooltip>
          </TooltipTrigger>
        ) : null}
      </TagList>
    </TagGroup>
  );
}
